<div class="mt-4" [formGroup]="formGroup" *ngIf="!isLoading">
  <span
    class="text-md font-semibold mt-4 mb-3 card-title"
    [ngClass]="{ required: fields.isRequired }"
  >
    {{ fields.displayName }}
  </span>

  <!-- Card Grid -->
  <div class="grid grid-cols-1 md:grid-cols-2 gap-5 mt-4">
    <ng-container *ngFor="let option of fieldsData; trackBy: trackById">
      <div
        *ngIf="option._id != 'None'"
        [ngClass]="{
          'border-success border-3': isSelected(option),
          'border-gray-300 opacity-50': isDisabled(option),
          'border-gray-300': !isSelected(option) && !isDisabled(option),
          'disabled-card': isDisabled(option),
        }"
        class="relative flex flex-col p-5 border bg-no-repeat bg-cover rounded-md h-[150px] hover:bg-secondary-active"
        [class.pointer-events-none]="isDisabled(option)"
      >
        <!-- Check icon -->
        <div class="flex items-center justify-between relative min-h-[32px]">
          <i
            class="absolute ki-solid ki-check-circle text-xl text-success transition-opacity duration-200"
            [ngClass]="{
              'opacity-100': isSelected(option),
              'opacity-0': !isSelected(option),
            }"
          >
          </i>

          <!-- Center Radio -->
          <input
            class="appearance-none"
            name="appearance_option"
            type="radio"
            value="2"
          />
        </div>

        <!-- Card Content -->
        <div class="flex items-center justify-between gap-4 mt-2">
          <div
            class="flex items-center gap-2.5"
            [ngClass]="{ 'disabled-card': isDisabled(option) }"
          >
            <div class="relative size-[44px] shrink-0">
              <img [src]="option.iconUrl" class="w-[56px] h-[56px]" />
            </div>
            <div class="flex flex-col">
              <a
                class="text-base font-semibold text-gray-900 hover:text-primary-active mb-px"
              >
                {{ option.platformName }}
              </a>
              <span class="text-sm font-medium text-gray-600">
                {{ option.description }}
              </span>
            </div>
          </div>

          <!-- Connect/Disconnect Buttons -->
          <button
            *ngIf="!isSelected(option) && option.fieldDependencies != null"
            class="btn btn-sm btn-primary ms-auto transition-opacity duration-200"
            [disabled]="isDisabled(option)"
            (click)="toggleSelection(option, 'connect')"
          >
            <div
              class="loader"
              *ngIf="loadingCards.has(option._id?.toString())"
            ></div>
            <i
              class="ki-filled ki-plus-squared text-lg"
              *ngIf="!loadingCards.has(option._id?.toString())"
            ></i>
            Connect
          </button>
          <button
            *ngIf="!isSelected(option) && option.fieldDependencies == null"
            class="btn btn-sm btn-primary ms-auto transition-opacity duration-200 cursor-default text-wrap"
          >
            Coming Soon
          </button>

          <button
            *ngIf="isSelected(option)"
            class="btn btn-sm btn-secondary ms-auto transition-opacity duration-200"
            (click)="toggleSelection(option, 'disconnect')"
          >
            <i class="ki-filled ki-minus-squared text-lg"></i>
            Disconnect
          </button>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Validation Error -->
  <div *ngIf="showValidationError" class="text-sm text-danger mt-2">
    Please select an option.
  </div>
</div>
<div *ngIf="isLoading" class="grid grid-cols-1 md:grid-cols-2 gap-5 mt-4">
  <div
    *ngFor="let i of [1, 2, 3, 4]"
    class="relative flex flex-col p-5 border border-gray-300 rounded-md h-[150px] bg-white dark:bg-coal-700"
  >
    <!-- Main Section -->
    <div class="flex items-center justify-between gap-4 mt-2">
      <!-- LEFT: Icon + Text -->
      <div class="flex items-center gap-3">
        <!-- Icon Loader -->
        <div
          class="w-10 h-10 bg-gray-300 dark:bg-coal-700 rounded-full shimmer-item"
        ></div>

        <!-- Text Column -->
        <div class="flex flex-col gap-3">
          <!-- Platform Name -->
          <div
            class="h-4 bg-gray-300 dark:bg-coal-700 rounded shimmer-item w-24"
          ></div>

          <!-- Description -->
          <div
            class="h-4 bg-gray-300 dark:bg-coal-700 rounded shimmer-item w-48"
          ></div>
        </div>
      </div>

      <!-- RIGHT: Button -->
      <div
        class="h-30px bg-gray-300 dark:bg-coal-700 rounded shimmer-item w-24"
      ></div>
    </div>
  </div>
</div>

<div
  class="modal"
  data-modal="true"
  data-modal-disable-scroll="false"
  [id]="'connection_modal_' + fields.fieldName"
>
  <div
    class="modal-content mx-auto my-5 w-full max-w-[600px] sm:rounded-lg shadow-lg bg-white dark:bg-coal-500"
  >
    <div class="modal-header flex justify-between items-center p-4 border-b">
      <span class="font-semibold text-base ms-2 card-title">{{
        modalTitle
      }}</span>
      
    </div>
    <div class="modal-body gap-5 p-4">
      <app-modal-renderer
        #modalRendererRef
        *ngIf="activeModalContext"
        [nodeId]="currentNodeId"
        (formSaved)="onModalFormSaved($event)"
        (closeModal)="closeModal('connection_modal_' + fields.fieldName)"
        [workflowData]="workflowData"
        [recordID]="recordID"
        [workflowId]="workflowId"
        (clickedOnPrevious)="clickedOnPrevious()"
        (header)="setModalTitle($event)"
        (checkPollingServiceForError)="checkPollingServiceForError($event)"
        [activeModalContext]="activeModalContext"
      ></app-modal-renderer>
    </div>
  </div>
</div>
